import { render, staticRenderFns } from "./DigitalMentalHealth.vue?vue&type=template&id=7a22f55a"
import script from "./DigitalMentalHealth.vue?vue&type=script&lang=js"
export * from "./DigitalMentalHealth.vue?vue&type=script&lang=js"
import style0 from "./DigitalMentalHealth.vue?vue&type=style&index=0&id=7a22f55a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports